import React from 'react';

const Horn = ({
  height = 48,
  width = 48,
  bellColor = '#C6C6C6',
  batteryColor = '#999999',
  handleColor = '#666666',
  emphasisColor = '#ef8158'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>speaker</title>
    <g>
      <path d="M16.32617,44.81836c-1.61328,0-3.15527-0.93066-3.85449-2.49707L5.2373,26.11035l8.98926-0.53711 l5.94141,13.31348c0.94727,2.12109-0.00879,4.61816-2.13086,5.56543C17.48145,44.7002,16.89941,44.81836,16.32617,44.81836z" fill={handleColor}/>
      <rect height="2" width="6" fill={emphasisColor} x="41" y="19"/>
      <rect height="6.00012" width="2.00032" fill={emphasisColor} transform="matrix(0.49992 0.86607 -0.86607 0.49992 29.32444 -30.78598)" x="40.32064" y="6.99994"/>
      <rect height="2.00032" width="6.00012" fill={emphasisColor} transform="matrix(0.86603 0.49999 -0.49999 0.86603 20.53541 -16.64093)" x="38.32074" y="28.99984"/>
      <path d="M33,17v6c1.65686,0,3-1.34314,3-3S34.65686,17,33,17z" fill={handleColor}/>
      <path d="M8,13c-3.85938,0-7,3.14062-7,7s3.14062,7,7,7h2V13H8z" fill={batteryColor} />
      <path d="M32.48438,3.125c-0.31641-0.1748-0.70605-0.16602-1.01465,0.02734L15.71289,13H10v14h5.71289 l15.75684,9.84766C31.63184,36.94922,31.81543,37,32,37c0.16699,0,0.33398-0.04199,0.48438-0.125 C32.80273,36.69824,33,36.36328,33,36V4C33,3.63672,32.80273,3.30176,32.48438,3.125z" fill="#C6C6C6"/>
      <rect height="14" width="2" fill={emphasisColor} x="9" y="13"/>
    </g>
  </svg>
);

export default Horn;
